// extracted by mini-css-extract-plugin
module.exports = {"container":"DragAndDropForm_container__2BQeq","draggableElem":"DragAndDropForm_draggableElem__Lp5uw","textContainer":"DragAndDropForm_textContainer__3wdE9"};